module.exports = __webpack_public_path__ + "img/collection-engagementRingsSignature@2x.de7464d.jpg";